// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.baord-details-header-container {
  margin: -1.5rem -1.5rem 0 -1.5rem; /* negate the p: "1.5rem" of parent box */
  padding: 1.25rem 1.5rem;
  background-color: #ffffff;
  border-bottom: 1px solid rgba(226, 232, 240, 0.8);
}

.board-details-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.board-details-orderId {
  display: flex;
  align-items: center;
  gap: 12px;
}

.board-details-orderId-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #64748b; /* text-slate-500 */
  margin: 0;
}

.board-details-id {
  font-size: 0.875rem;
  font-weight: 600;
  color: #2a71ff; /* text-[#2A71FF] */
  margin: 0;
}

.board-details-status {
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  border-radius: 50px;
  border: 1px solid #bfdbfe; /* border-blue-200 */
  background-color: #eff6ff; /* bg-blue-50 */
  color: #1d4ed8; /* text-blue-700 */
  padding: 2px 8px;
  font-size: 0.688rem;
  font-weight: 600;
  text-transform: uppercase;
}

.board-details-status p {
  margin: 0;
}

.board-details-slot {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 0.688rem;
  font-weight: 600;
  color: #475569; /* slate-600 */
  background-color: #f1f5f9; /* slate-100 */
  border: 1px solid #cbd5e1; /* slate-300 */
  border-radius: 6px;
  padding: 2px 8px;
  text-transform: uppercase;
}

.board-details-slot p {
  margin: 0;
}

.board-details-close-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid rgba(226, 232, 240, 0.8);
  background-color: #ffffff;
  color: #64748b;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease;
  cursor: pointer;
}

.board-details-close-btn:hover {
  border-color: #cbd5e1;
  background-color: #f8fafc;
  color: #0f172a;
}

/* Content wrapper */
.board-item-details-content {
  margin: 0 -1.5rem -1.5rem -1.5rem; /* negate parent box padding */
  padding: 1.5rem;

  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
  height: calc(100vh - 72px); /* adjust based on header height */
  overflow-y: auto;
}

.item-details-content-padding-bottom {
  padding-bottom: calc(1.5rem + 64px); /* space for fixed action buttons */
}

/* Custom scrollbar style */
.board-item-details-content::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
.board-item-details-content::-webkit-scrollbar-track {
  background: transparent;
}
.board-item-details-content::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 9999px;
}
.board-item-details-content::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* Order comments / instructions block */
.board-item-details-instruction {
  border-radius: 16px;
  border: 1px solid #dbeafe; /* border-blue-100 */
  background-color: rgba(239, 246, 255, 0.7); /* bg-blue-50/70 */
  padding: 16px;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.04);
  margin-bottom: 20px;
}

.board-item-details-instruction-heading {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.813rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.14em;
  color: #475569;
}

.board-details-instruction-value {
  margin-top: 12px;
  margin-bottom: 0;
  font-size: 1rem;
  font-weight: 600;
  color: #2a71ff;
}

/* 5 Card Header Grid */
.board-details-grid-cards {
  display: grid;
  gap: 12px;
  margin-bottom: 20px;
  grid-template-columns: repeat(1, minmax(0, 1fr));
}

@media (min-width: 640px) {
  .board-details-grid-cards {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (min-width: 1200px) {
  .board-details-grid-cards {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
}

.board-details-card {
  display: flex;
  flex-direction: column;
  min-height: 102px;
  border-radius: 16px;
  border: 1px solid rgba(226, 232, 240, 0.8);
  background-color: #ffffff;
  padding: 16px;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.06);
}

.board-details-card-label {
  font-size: 0.688rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.16em;
  color: #94a3b8;
  margin-bottom: 12px;
  margin-top: 0;
}

.board-details-card-badge {
  margin-top: auto;
  display: inline-flex;
  align-items: center;
  border-radius: 50px;
  border: 1px solid;
  padding: 4px 10px;
  font-size: 0.75rem;
  font-weight: 600;
  width: max-content;
}

.board-details-card-value {
  margin-top: auto;
  font-size: 0.875rem;
  font-weight: 600;
  color: #0f172a;
  margin-bottom: 0;
}

.board-details-card-value-with-icon {
  margin-top: auto;
  display: flex;
  align-items: center;
  gap: 8px;
}

.board-details-card-value-with-icon .board-details-card-value {
  margin-top: 0;
}

/* Two-column layout grid */
.board-details-columns-grid {
  display: grid;
  gap: 20px;
  grid-template-columns: 1fr;
}

@media (min-width: 1200px) {
  .board-details-columns-grid {
    grid-template-columns: 1.05fr 0.95fr;
  }
}

.board-details-column-left {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.board-details-column-right {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* Payment Status Card */
.board-payment-card {
  border: 1px solid rgba(226, 232, 240, 0.8);
  background-color: #ffffff;
  border-radius: 16px;
  padding: 16px;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.06);
}

.board-payment-grid {
  display: grid;
  gap: 16px;
  grid-template-columns: 1fr;
}

@media (min-width: 640px) {
  .board-payment-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

.board-payment-label {
  font-size: 0.688rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.16em;
  color: #94a3b8;
  margin-bottom: 12px;
  margin-top: 0;
}

.board-payment-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border-radius: 9999px;
  border: 1px solid;
  padding: 4px 12px;
  font-size: 0.75rem;
  font-weight: 600;
  width: max-content;
}

.board-payment-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
}

.board-payment-method-value {
  margin-top: 12px;
  margin-bottom: 0;
  font-size: 0.875rem;
  font-weight: 600;
  color: #0f172a;
}

/* Order Items Card */
.board-items-card {
  border: 1px solid rgba(226, 232, 240, 0.8);
  background-color: #ffffff;
  border-radius: 16px;
  padding: 16px;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.06);
}

.board-items-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.board-items-title {
  font-size: 0.813rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.14em;
  color: #64748b;
  margin: 0;
}

.board-items-count {
  font-size: 0.75rem;
  font-weight: 500;
  color: #94a3b8;
}

.board-items-list-container {
  overflow: hidden;
  border-radius: 20px;
  border: 1px solid rgba(226, 232, 240, 0.8);
  background-color: rgba(248, 250, 252, 0.4);
}

.board-items-list {
  display: flex;
  flex-direction: column;
}

.board-item-row {
  padding: 12px 16px;
  border-bottom: 1px dashed rgba(226, 232, 240, 0.8);
}

.board-item-row:last-child {
  border-bottom: none;
}

.board-item-row-content {
  display: flex;
  width: 100%;
}

.board-item-info {
  width: 100%;
}

.board-item-name-price {
  display: flex;
  justify-content: space-between;
  align-items: start;
  gap: 12px;
}

.board-item-name {
  font-size: 0.875rem;
  font-weight: 500;
  color: #0f172a;
  margin: 0;
}

.board-item-price {
  font-size: 0.875rem;
  font-weight: 600;
  color: #334155;
  margin: 0;
}

.board-item-qty {
  margin: 4px 0 0 0;
  font-size: 0.875rem;
  color: #475569;
}

.board-item-addons {
  margin-top: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.board-item-addon-tag {
  display: inline-flex;
  align-items: center;
  border-radius: 9999px;
  border: 1px solid #e2e8f0;
  background-color: #ffffff;
  padding: 2px 12px;
  font-size: 0.75rem;
  font-weight: 500;
  color: #64748b;
}

.board-item-comment-box {
  margin-top: 8px;
}

.board-item-comment-tag {
  display: inline-flex;
  max-width: 100%;
  align-items: center;
  gap: 8px;
  border-radius: 9999px;
  background-color: #fffbeb; /* amber-50 */
  padding: 6px 12px;
  font-size: 0.75rem;
  font-weight: 500;
  color: #92400e; /* amber-800 */
  box-shadow: inset 0 0 0 1px #fef3c7; /* ring-amber-100 */
}

.board-item-comment-text {
  line-height: 1.25rem;
}

/* Rider Information Card */
.board-rider-card {
  border: 1px solid rgba(226, 232, 240, 0.8);
  background-color: #ffffff;
  border-radius: 16px;
  padding: 16px;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.06);
}

.board-rider-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  gap: 12px;
}

.board-rider-title {
  font-size: 0.813rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.14em;
  color: #64748b;
  margin: 0;
}

.board-rider-status-tag {
  display: inline-flex;
  align-items: center;
  border-radius: 9999px;
  border: 1px solid;
  padding: 4px 12px;
  font-size: 0.75rem;
  font-weight: 600;
}

.board-rider-status-tag-unassigned {
  display: inline-flex;
  align-items: center;
  border-radius: 9999px;
  border: 1px solid #fcd34d;
  padding: 4px 12px;
  font-size: 0.75rem;
  font-weight: 600;
  background-color: #fffbeb;
  color: #b45309;
}

.board-rider-unassigned-body {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.board-rider-unassigned-text {
  font-size: 0.875rem;
  color: #64748b;
  text-align: center;
  padding: 8px 0;
  margin: 0;
}

.board-rider-add-partner-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  justify-content: space-between;
  padding: 8px 16px;
  border-radius: 12px;
  border: 1px solid #bfdbfe;
  background-color: #eff6ff;
  color: #1d4ed8;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease;
  min-height: 36px;
  white-space: nowrap;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  outline: none;
}

.board-rider-add-partner-btn:focus-visible {
  outline: none;
  box-shadow: 0 0 0 1px rgba(42, 113, 255, 0.5);
}

.board-rider-add-partner-btn:active {
  box-shadow: none;
}

.board-rider-add-partner-btn:hover {
  background-color: #dbeafe;
  color: #1e40af;
}

.board-rider-add-partner-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}

.board-rider-add-partner-left {
  display: flex;
  align-items: center;
  gap: 8px;
}

.board-rider-body {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 16px;
}

.board-rider-fields-grid {
  display: grid;
  gap: 12px;
  grid-template-columns: 1fr;
}

@media (min-width: 640px) {
  .board-rider-fields-grid {
    grid-template-columns: 1fr 140px;
  }
}

.board-rider-field-box {
  border-radius: 20px;
  border: 1px solid rgba(226, 232, 240, 0.8);
  background-color: rgba(248, 250, 252, 0.4);
  padding: 12px 16px;
}

.board-rider-field-label {
  font-size: 0.75rem;
  color: #94a3b8;
  margin: 0;
}

.board-rider-field-value {
  margin-top: 4px;
  font-size: 0.875rem;
  font-weight: 600;
  color: #0f172a;
  margin-bottom: 0;
}

.board-rider-otp-box {
  border-radius: 50px;
  background-color: #2a71ff;
  padding: 12px 16px;
  color: #ffffff;
  box-shadow: 0 10px 24px rgba(42, 113, 255, 0.22);
}

.board-rider-otp-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.board-rider-otp-label {
  font-size: 14px;
  font-weight: 600;
}

.board-rider-otp-value {
  font-size: 0.875rem;
  font-weight: 600;
  letter-spacing: 2px;
}

/* Customer Information Card */
.board-customer-card {
  border: 1px solid rgba(226, 232, 240, 0.8);
  background-color: #ffffff;
  border-radius: 16px;
  padding: 16px;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.06);
}

.board-customer-title {
  font-size: 0.813rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.14em;
  color: #64748b;
  margin-bottom: 16px;
}

.board-customer-body {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.board-customer-grid-name-contact {
  display: grid;
  gap: 12px;
  grid-template-columns: 1fr;
}

@media (min-width: 640px) {
  .board-customer-grid-name-contact {
    grid-template-columns: 1fr 160px;
  }
}

.board-customer-grid-geo {
  display: grid;
  gap: 12px;
  grid-template-columns: 1fr;
}

@media (min-width: 640px) {
  .board-customer-grid-geo {
    grid-template-columns: 1fr 120px;
  }
}

.board-customer-field-box {
  border-radius: 20px;
  border: 1px solid rgba(226, 232, 240, 0.8);
  background-color: rgba(248, 250, 252, 0.4);
  padding: 12px 16px;
}

.board-customer-field-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.board-customer-field-label {
  font-size: 0.75rem;
  color: #94a3b8;
  margin: 0;
}

.board-customer-copy-btn {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  opacity: 0.7;
  transition: opacity 0.2s;
}

.board-customer-copy-btn:hover {
  opacity: 1;
}

.board-customer-field-value {
  margin-top: 4px;
  font-size: 0.875rem;
  font-weight: 600;
  color: #0f172a;
  margin-bottom: 0;
}

.board-customer-map-link {
  color: #2a71ff;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  transition: opacity 0.2s;
}

.board-customer-map-link:hover {
  opacity: 0.8;
}

/* Pricing Details Card */
.board-pricing-card {
  border: 1px solid rgba(226, 232, 240, 0.8);
  background-color: #ffffff;
  border-radius: 16px;
  padding: 16px;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.06);
}

.board-pricing-title {
  font-size: 0.813rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.14em;
  color: #64748b;
  margin-bottom: 16px;
}

.board-pricing-body {
  border-radius: 20px;
  border: 1px solid rgba(226, 232, 240, 0.8);
  background-color: rgba(248, 250, 252, 0.4);
  padding: 16px;
}

.board-pricing-rows {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.board-pricing-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 0.875rem;
  color: #475569;
}

.board-pricing-divider {
  margin: 16px 0;
  border-top: 1px dashed #cbd5e1;
}

.board-pricing-total-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 1.125rem;
  font-weight: 600;
  color: #0f172a;
}

.single-page-open-box {
  flex: 1;
}

/* Bottom Actions Box */
.board-item-details-right-box {
  margin-top: 24px;
  border-top: 1px solid rgba(226, 232, 240, 0.8);
}

.board-item-details-actions {
  flex: 1;
}

.board-logistic-retry-container {
  display: flex;
  align-items: center;
  gap: 8px;
}

.board-tiem-details-reprint-buttons {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: #ffffff;
  padding: 10px;
}

.board-tiem-details-reprint-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 48px;
  padding: 0 16px;
  border-radius: 20px;
  border: 1px solid #e2e8f0;
  background-color: white;
  font-size: 14px;
  font-weight: 500;
  color: #334155;
  cursor: pointer;
  transition: all 0.2s;
}

.board-tiem-details-reprint-btn:hover:not(:disabled) {
  border-color: #cbd5e1;
  background-color: #f8fafc;
  color: #0f172a;
}

.board-tiem-details-reprint-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.board-tiem-details-reject-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 48px;
  padding: 0 16px;
  border-radius: 20px;
  border: 1px solid #e90000;
  background-color: transparent;
  font-size: 14px;
  font-weight: 500;
  color: #e90000;
  cursor: pointer;
  transition: all 0.2s;
}

.board-tiem-details-reject-btn:hover:not(:disabled) {
  background-color: #e90000;
  color: #ffffff;
}

.board-tiem-details-reject-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ── Dark theme ── */
.dark .delivery-board-modal-box {
  background-color: #1e293b !important;
  color: #f1f5f9;
}

.dark .baord-details-header-container {
  background-color: #1e293b;
  border-bottom-color: #334155;
}

.dark .board-details-close-btn {
  background-color: #334155;
  border-color: #475569;
  color: #94a3b8;
}

.dark .board-details-close-btn:hover {
  background-color: #475569;
  border-color: #64748b;
  color: #f1f5f9;
}

.dark .board-item-details-content {
  background: linear-gradient(180deg, #1e293b 0%, #0f172a 100%);
}

.dark .board-item-details-instruction {
  background-color: rgba(30, 58, 95, 0.5);
  border-color: #1e40af;
}

.dark .board-item-details-instruction-heading {
  color: #94a3b8;
}

.dark .board-details-card {
  background-color: #1e293b;
  border-color: #334155;
}

.dark .board-details-card-value {
  color: #f1f5f9;
}

.dark .board-payment-card {
  background-color: #1e293b;
  border-color: #334155;
}

.dark .board-payment-method-value {
  color: #f1f5f9;
}

.dark .board-items-card {
  background-color: #1e293b;
  border-color: #334155;
}

.dark .board-items-list-container {
  background-color: rgba(15, 23, 42, 0.4);
  border-color: #334155;
}

.dark .board-item-row {
  border-bottom-color: #334155;
}

.dark .board-item-name {
  color: #f1f5f9;
}

.dark .board-item-price {
  color: #e2e8f0;
}

.dark .board-item-qty {
  color: #94a3b8;
}

.dark .board-item-addon-tag {
  background-color: #1e293b;
  border-color: #334155;
  color: #94a3b8;
}

.dark .board-rider-card {
  background-color: #1e293b;
  border-color: #334155;
}

.dark .board-rider-field-box {
  background-color: rgba(15, 23, 42, 0.4);
  border-color: #334155;
}

.dark .board-rider-field-value {
  color: #f1f5f9;
}

.dark .board-customer-card {
  background-color: #1e293b;
  border-color: #334155;
}

.dark .board-customer-field-box {
  background-color: rgba(15, 23, 42, 0.4);
  border-color: #334155;
}

.dark .board-customer-field-value {
  color: #f1f5f9;
}

.dark .board-pricing-card {
  background-color: #1e293b;
  border-color: #334155;
}

.dark .board-pricing-body {
  background-color: rgba(15, 23, 42, 0.4);
  border-color: #334155;
}

.dark .board-pricing-row {
  color: #94a3b8;
}

.dark .board-pricing-total-row {
  color: #f1f5f9;
}

.dark .board-pricing-divider {
  border-top-color: #334155;
}

.dark .board-tiem-details-reprint-buttons {
  background-color: #1e293b;
  border-top: 1px solid #334155;
}

.dark .board-tiem-details-reprint-btn {
  background-color: #1e293b;
  border-color: #334155;
  color: #e2e8f0;
}

.dark .board-tiem-details-reprint-btn:hover:not(:disabled) {
  background-color: #334155;
  border-color: #475569;
  color: #f1f5f9;
}

.dark .board-details-slot {
  background-color: #1e293b;
  border-color: #334155;
  color: #94a3b8;
}

.dark .board-item-details-right-box {
  border-top-color: #334155;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/delivery/components/BoardItemDetails.css"],"names":[],"mappings":"AAAA;EACE,iCAAiC,EAAE,yCAAyC;EAC5E,uBAAuB;EACvB,yBAAyB;EACzB,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc,EAAE,mBAAmB;EACnC,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc,EAAE,mBAAmB;EACnC,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB,EAAE,oBAAoB;EAC/C,yBAAyB,EAAE,eAAe;EAC1C,cAAc,EAAE,kBAAkB;EAClC,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,cAAc,EAAE,cAAc;EAC9B,yBAAyB,EAAE,cAAc;EACzC,yBAAyB,EAAE,cAAc;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,yBAAyB;EACzB,cAAc;EACd,2CAA2C;EAC3C,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,iCAAiC,EAAE,8BAA8B;EACjE,eAAe;;EAEf,6DAA6D;EAC7D,0BAA0B,EAAE,kCAAkC;EAC9D,gBAAgB;AAClB;;AAEA;EACE,mCAAmC,EAAE,mCAAmC;AAC1E;;AAEA,2BAA2B;AAC3B;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;;AAEA,wCAAwC;AACxC;EACE,mBAAmB;EACnB,yBAAyB,EAAE,oBAAoB;EAC/C,0CAA0C,EAAE,kBAAkB;EAC9D,aAAa;EACb,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;EACzB,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;AACf;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE;IACE,oCAAoC;EACtC;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,wBAAwB;AACxB;EACE,0CAA0C;EAC1C,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,0CAA0C;EAC1C,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;EACrB,yBAAyB,EAAE,aAAa;EACxC,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc,EAAE,cAAc;EAC9B,mCAAmC,EAAE,mBAAmB;AAC1D;;AAEA;EACE,oBAAoB;AACtB;;AAEA,2BAA2B;AAC3B;EACE,0CAA0C;EAC1C,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,uDAAuD;EACvD,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,0CAA0C;EAC1C,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE,aAAa;EACb,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA,yBAAyB;AACzB;EACE,0CAA0C;EAC1C,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,OAAO;AACT;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,OAAO;EACP,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,uCAAuC;EACvC,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,uCAAuC;EACvC,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,uCAAuC;EACvC,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,uCAAuC;EACvC,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,uCAAuC;EACvC,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".baord-details-header-container {\n  margin: -1.5rem -1.5rem 0 -1.5rem; /* negate the p: \"1.5rem\" of parent box */\n  padding: 1.25rem 1.5rem;\n  background-color: #ffffff;\n  border-bottom: 1px solid rgba(226, 232, 240, 0.8);\n}\n\n.board-details-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.board-details-orderId {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.board-details-orderId-label {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #64748b; /* text-slate-500 */\n  margin: 0;\n}\n\n.board-details-id {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #2a71ff; /* text-[#2A71FF] */\n  margin: 0;\n}\n\n.board-details-status {\n  white-space: nowrap;\n  display: inline-flex;\n  align-items: center;\n  border-radius: 50px;\n  border: 1px solid #bfdbfe; /* border-blue-200 */\n  background-color: #eff6ff; /* bg-blue-50 */\n  color: #1d4ed8; /* text-blue-700 */\n  padding: 2px 8px;\n  font-size: 0.688rem;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.board-details-status p {\n  margin: 0;\n}\n\n.board-details-slot {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 0.688rem;\n  font-weight: 600;\n  color: #475569; /* slate-600 */\n  background-color: #f1f5f9; /* slate-100 */\n  border: 1px solid #cbd5e1; /* slate-300 */\n  border-radius: 6px;\n  padding: 2px 8px;\n  text-transform: uppercase;\n}\n\n.board-details-slot p {\n  margin: 0;\n}\n\n.board-details-close-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  border: 1px solid rgba(226, 232, 240, 0.8);\n  background-color: #ffffff;\n  color: #64748b;\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  transition: all 0.2s ease;\n  cursor: pointer;\n}\n\n.board-details-close-btn:hover {\n  border-color: #cbd5e1;\n  background-color: #f8fafc;\n  color: #0f172a;\n}\n\n/* Content wrapper */\n.board-item-details-content {\n  margin: 0 -1.5rem -1.5rem -1.5rem; /* negate parent box padding */\n  padding: 1.5rem;\n\n  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);\n  height: calc(100vh - 72px); /* adjust based on header height */\n  overflow-y: auto;\n}\n\n.item-details-content-padding-bottom {\n  padding-bottom: calc(1.5rem + 64px); /* space for fixed action buttons */\n}\n\n/* Custom scrollbar style */\n.board-item-details-content::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n.board-item-details-content::-webkit-scrollbar-track {\n  background: transparent;\n}\n.board-item-details-content::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 9999px;\n}\n.board-item-details-content::-webkit-scrollbar-thumb:hover {\n  background: #94a3b8;\n}\n\n/* Order comments / instructions block */\n.board-item-details-instruction {\n  border-radius: 16px;\n  border: 1px solid #dbeafe; /* border-blue-100 */\n  background-color: rgba(239, 246, 255, 0.7); /* bg-blue-50/70 */\n  padding: 16px;\n  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.04);\n  margin-bottom: 20px;\n}\n\n.board-item-details-instruction-heading {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.813rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.14em;\n  color: #475569;\n}\n\n.board-details-instruction-value {\n  margin-top: 12px;\n  margin-bottom: 0;\n  font-size: 1rem;\n  font-weight: 600;\n  color: #2a71ff;\n}\n\n/* 5 Card Header Grid */\n.board-details-grid-cards {\n  display: grid;\n  gap: 12px;\n  margin-bottom: 20px;\n  grid-template-columns: repeat(1, minmax(0, 1fr));\n}\n\n@media (min-width: 640px) {\n  .board-details-grid-cards {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (min-width: 1200px) {\n  .board-details-grid-cards {\n    grid-template-columns: repeat(5, minmax(0, 1fr));\n  }\n}\n\n.board-details-card {\n  display: flex;\n  flex-direction: column;\n  min-height: 102px;\n  border-radius: 16px;\n  border: 1px solid rgba(226, 232, 240, 0.8);\n  background-color: #ffffff;\n  padding: 16px;\n  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.06);\n}\n\n.board-details-card-label {\n  font-size: 0.688rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.16em;\n  color: #94a3b8;\n  margin-bottom: 12px;\n  margin-top: 0;\n}\n\n.board-details-card-badge {\n  margin-top: auto;\n  display: inline-flex;\n  align-items: center;\n  border-radius: 50px;\n  border: 1px solid;\n  padding: 4px 10px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  width: max-content;\n}\n\n.board-details-card-value {\n  margin-top: auto;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #0f172a;\n  margin-bottom: 0;\n}\n\n.board-details-card-value-with-icon {\n  margin-top: auto;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.board-details-card-value-with-icon .board-details-card-value {\n  margin-top: 0;\n}\n\n/* Two-column layout grid */\n.board-details-columns-grid {\n  display: grid;\n  gap: 20px;\n  grid-template-columns: 1fr;\n}\n\n@media (min-width: 1200px) {\n  .board-details-columns-grid {\n    grid-template-columns: 1.05fr 0.95fr;\n  }\n}\n\n.board-details-column-left {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.board-details-column-right {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n/* Payment Status Card */\n.board-payment-card {\n  border: 1px solid rgba(226, 232, 240, 0.8);\n  background-color: #ffffff;\n  border-radius: 16px;\n  padding: 16px;\n  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.06);\n}\n\n.board-payment-grid {\n  display: grid;\n  gap: 16px;\n  grid-template-columns: 1fr;\n}\n\n@media (min-width: 640px) {\n  .board-payment-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n.board-payment-label {\n  font-size: 0.688rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.16em;\n  color: #94a3b8;\n  margin-bottom: 12px;\n  margin-top: 0;\n}\n\n.board-payment-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  border-radius: 9999px;\n  border: 1px solid;\n  padding: 4px 12px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  width: max-content;\n}\n\n.board-payment-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n}\n\n.board-payment-method-value {\n  margin-top: 12px;\n  margin-bottom: 0;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n/* Order Items Card */\n.board-items-card {\n  border: 1px solid rgba(226, 232, 240, 0.8);\n  background-color: #ffffff;\n  border-radius: 16px;\n  padding: 16px;\n  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.06);\n}\n\n.board-items-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 16px;\n}\n\n.board-items-title {\n  font-size: 0.813rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.14em;\n  color: #64748b;\n  margin: 0;\n}\n\n.board-items-count {\n  font-size: 0.75rem;\n  font-weight: 500;\n  color: #94a3b8;\n}\n\n.board-items-list-container {\n  overflow: hidden;\n  border-radius: 20px;\n  border: 1px solid rgba(226, 232, 240, 0.8);\n  background-color: rgba(248, 250, 252, 0.4);\n}\n\n.board-items-list {\n  display: flex;\n  flex-direction: column;\n}\n\n.board-item-row {\n  padding: 12px 16px;\n  border-bottom: 1px dashed rgba(226, 232, 240, 0.8);\n}\n\n.board-item-row:last-child {\n  border-bottom: none;\n}\n\n.board-item-row-content {\n  display: flex;\n  width: 100%;\n}\n\n.board-item-info {\n  width: 100%;\n}\n\n.board-item-name-price {\n  display: flex;\n  justify-content: space-between;\n  align-items: start;\n  gap: 12px;\n}\n\n.board-item-name {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #0f172a;\n  margin: 0;\n}\n\n.board-item-price {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #334155;\n  margin: 0;\n}\n\n.board-item-qty {\n  margin: 4px 0 0 0;\n  font-size: 0.875rem;\n  color: #475569;\n}\n\n.board-item-addons {\n  margin-top: 8px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.board-item-addon-tag {\n  display: inline-flex;\n  align-items: center;\n  border-radius: 9999px;\n  border: 1px solid #e2e8f0;\n  background-color: #ffffff;\n  padding: 2px 12px;\n  font-size: 0.75rem;\n  font-weight: 500;\n  color: #64748b;\n}\n\n.board-item-comment-box {\n  margin-top: 8px;\n}\n\n.board-item-comment-tag {\n  display: inline-flex;\n  max-width: 100%;\n  align-items: center;\n  gap: 8px;\n  border-radius: 9999px;\n  background-color: #fffbeb; /* amber-50 */\n  padding: 6px 12px;\n  font-size: 0.75rem;\n  font-weight: 500;\n  color: #92400e; /* amber-800 */\n  box-shadow: inset 0 0 0 1px #fef3c7; /* ring-amber-100 */\n}\n\n.board-item-comment-text {\n  line-height: 1.25rem;\n}\n\n/* Rider Information Card */\n.board-rider-card {\n  border: 1px solid rgba(226, 232, 240, 0.8);\n  background-color: #ffffff;\n  border-radius: 16px;\n  padding: 16px;\n  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.06);\n}\n\n.board-rider-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 16px;\n  gap: 12px;\n}\n\n.board-rider-title {\n  font-size: 0.813rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.14em;\n  color: #64748b;\n  margin: 0;\n}\n\n.board-rider-status-tag {\n  display: inline-flex;\n  align-items: center;\n  border-radius: 9999px;\n  border: 1px solid;\n  padding: 4px 12px;\n  font-size: 0.75rem;\n  font-weight: 600;\n}\n\n.board-rider-status-tag-unassigned {\n  display: inline-flex;\n  align-items: center;\n  border-radius: 9999px;\n  border: 1px solid #fcd34d;\n  padding: 4px 12px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  background-color: #fffbeb;\n  color: #b45309;\n}\n\n.board-rider-unassigned-body {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.board-rider-unassigned-text {\n  font-size: 0.875rem;\n  color: #64748b;\n  text-align: center;\n  padding: 8px 0;\n  margin: 0;\n}\n\n.board-rider-add-partner-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  justify-content: space-between;\n  padding: 8px 16px;\n  border-radius: 12px;\n  border: 1px solid #bfdbfe;\n  background-color: #eff6ff;\n  color: #1d4ed8;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s ease, color 0.2s ease;\n  min-height: 36px;\n  white-space: nowrap;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n  outline: none;\n}\n\n.board-rider-add-partner-btn:focus-visible {\n  outline: none;\n  box-shadow: 0 0 0 1px rgba(42, 113, 255, 0.5);\n}\n\n.board-rider-add-partner-btn:active {\n  box-shadow: none;\n}\n\n.board-rider-add-partner-btn:hover {\n  background-color: #dbeafe;\n  color: #1e40af;\n}\n\n.board-rider-add-partner-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n\n.board-rider-add-partner-left {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.board-rider-body {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-top: 16px;\n}\n\n.board-rider-fields-grid {\n  display: grid;\n  gap: 12px;\n  grid-template-columns: 1fr;\n}\n\n@media (min-width: 640px) {\n  .board-rider-fields-grid {\n    grid-template-columns: 1fr 140px;\n  }\n}\n\n.board-rider-field-box {\n  border-radius: 20px;\n  border: 1px solid rgba(226, 232, 240, 0.8);\n  background-color: rgba(248, 250, 252, 0.4);\n  padding: 12px 16px;\n}\n\n.board-rider-field-label {\n  font-size: 0.75rem;\n  color: #94a3b8;\n  margin: 0;\n}\n\n.board-rider-field-value {\n  margin-top: 4px;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #0f172a;\n  margin-bottom: 0;\n}\n\n.board-rider-otp-box {\n  border-radius: 50px;\n  background-color: #2a71ff;\n  padding: 12px 16px;\n  color: #ffffff;\n  box-shadow: 0 10px 24px rgba(42, 113, 255, 0.22);\n}\n\n.board-rider-otp-content {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.board-rider-otp-label {\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.board-rider-otp-value {\n  font-size: 0.875rem;\n  font-weight: 600;\n  letter-spacing: 2px;\n}\n\n/* Customer Information Card */\n.board-customer-card {\n  border: 1px solid rgba(226, 232, 240, 0.8);\n  background-color: #ffffff;\n  border-radius: 16px;\n  padding: 16px;\n  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.06);\n}\n\n.board-customer-title {\n  font-size: 0.813rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.14em;\n  color: #64748b;\n  margin-bottom: 16px;\n}\n\n.board-customer-body {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.board-customer-grid-name-contact {\n  display: grid;\n  gap: 12px;\n  grid-template-columns: 1fr;\n}\n\n@media (min-width: 640px) {\n  .board-customer-grid-name-contact {\n    grid-template-columns: 1fr 160px;\n  }\n}\n\n.board-customer-grid-geo {\n  display: grid;\n  gap: 12px;\n  grid-template-columns: 1fr;\n}\n\n@media (min-width: 640px) {\n  .board-customer-grid-geo {\n    grid-template-columns: 1fr 120px;\n  }\n}\n\n.board-customer-field-box {\n  border-radius: 20px;\n  border: 1px solid rgba(226, 232, 240, 0.8);\n  background-color: rgba(248, 250, 252, 0.4);\n  padding: 12px 16px;\n}\n\n.board-customer-field-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.board-customer-field-label {\n  font-size: 0.75rem;\n  color: #94a3b8;\n  margin: 0;\n}\n\n.board-customer-copy-btn {\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  opacity: 0.7;\n  transition: opacity 0.2s;\n}\n\n.board-customer-copy-btn:hover {\n  opacity: 1;\n}\n\n.board-customer-field-value {\n  margin-top: 4px;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #0f172a;\n  margin-bottom: 0;\n}\n\n.board-customer-map-link {\n  color: #2a71ff;\n  text-decoration: none;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  transition: opacity 0.2s;\n}\n\n.board-customer-map-link:hover {\n  opacity: 0.8;\n}\n\n/* Pricing Details Card */\n.board-pricing-card {\n  border: 1px solid rgba(226, 232, 240, 0.8);\n  background-color: #ffffff;\n  border-radius: 16px;\n  padding: 16px;\n  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.06);\n}\n\n.board-pricing-title {\n  font-size: 0.813rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.14em;\n  color: #64748b;\n  margin-bottom: 16px;\n}\n\n.board-pricing-body {\n  border-radius: 20px;\n  border: 1px solid rgba(226, 232, 240, 0.8);\n  background-color: rgba(248, 250, 252, 0.4);\n  padding: 16px;\n}\n\n.board-pricing-rows {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.board-pricing-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 0.875rem;\n  color: #475569;\n}\n\n.board-pricing-divider {\n  margin: 16px 0;\n  border-top: 1px dashed #cbd5e1;\n}\n\n.board-pricing-total-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 1.125rem;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.single-page-open-box {\n  flex: 1;\n}\n\n/* Bottom Actions Box */\n.board-item-details-right-box {\n  margin-top: 24px;\n  border-top: 1px solid rgba(226, 232, 240, 0.8);\n}\n\n.board-item-details-actions {\n  flex: 1;\n}\n\n.board-logistic-retry-container {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.board-tiem-details-reprint-buttons {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  background-color: #ffffff;\n  padding: 10px;\n}\n\n.board-tiem-details-reprint-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  height: 48px;\n  padding: 0 16px;\n  border-radius: 20px;\n  border: 1px solid #e2e8f0;\n  background-color: white;\n  font-size: 14px;\n  font-weight: 500;\n  color: #334155;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.board-tiem-details-reprint-btn:hover:not(:disabled) {\n  border-color: #cbd5e1;\n  background-color: #f8fafc;\n  color: #0f172a;\n}\n\n.board-tiem-details-reprint-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.board-tiem-details-reject-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  height: 48px;\n  padding: 0 16px;\n  border-radius: 20px;\n  border: 1px solid #e90000;\n  background-color: transparent;\n  font-size: 14px;\n  font-weight: 500;\n  color: #e90000;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.board-tiem-details-reject-btn:hover:not(:disabled) {\n  background-color: #e90000;\n  color: #ffffff;\n}\n\n.board-tiem-details-reject-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* ── Dark theme ── */\n.dark .delivery-board-modal-box {\n  background-color: #1e293b !important;\n  color: #f1f5f9;\n}\n\n.dark .baord-details-header-container {\n  background-color: #1e293b;\n  border-bottom-color: #334155;\n}\n\n.dark .board-details-close-btn {\n  background-color: #334155;\n  border-color: #475569;\n  color: #94a3b8;\n}\n\n.dark .board-details-close-btn:hover {\n  background-color: #475569;\n  border-color: #64748b;\n  color: #f1f5f9;\n}\n\n.dark .board-item-details-content {\n  background: linear-gradient(180deg, #1e293b 0%, #0f172a 100%);\n}\n\n.dark .board-item-details-instruction {\n  background-color: rgba(30, 58, 95, 0.5);\n  border-color: #1e40af;\n}\n\n.dark .board-item-details-instruction-heading {\n  color: #94a3b8;\n}\n\n.dark .board-details-card {\n  background-color: #1e293b;\n  border-color: #334155;\n}\n\n.dark .board-details-card-value {\n  color: #f1f5f9;\n}\n\n.dark .board-payment-card {\n  background-color: #1e293b;\n  border-color: #334155;\n}\n\n.dark .board-payment-method-value {\n  color: #f1f5f9;\n}\n\n.dark .board-items-card {\n  background-color: #1e293b;\n  border-color: #334155;\n}\n\n.dark .board-items-list-container {\n  background-color: rgba(15, 23, 42, 0.4);\n  border-color: #334155;\n}\n\n.dark .board-item-row {\n  border-bottom-color: #334155;\n}\n\n.dark .board-item-name {\n  color: #f1f5f9;\n}\n\n.dark .board-item-price {\n  color: #e2e8f0;\n}\n\n.dark .board-item-qty {\n  color: #94a3b8;\n}\n\n.dark .board-item-addon-tag {\n  background-color: #1e293b;\n  border-color: #334155;\n  color: #94a3b8;\n}\n\n.dark .board-rider-card {\n  background-color: #1e293b;\n  border-color: #334155;\n}\n\n.dark .board-rider-field-box {\n  background-color: rgba(15, 23, 42, 0.4);\n  border-color: #334155;\n}\n\n.dark .board-rider-field-value {\n  color: #f1f5f9;\n}\n\n.dark .board-customer-card {\n  background-color: #1e293b;\n  border-color: #334155;\n}\n\n.dark .board-customer-field-box {\n  background-color: rgba(15, 23, 42, 0.4);\n  border-color: #334155;\n}\n\n.dark .board-customer-field-value {\n  color: #f1f5f9;\n}\n\n.dark .board-pricing-card {\n  background-color: #1e293b;\n  border-color: #334155;\n}\n\n.dark .board-pricing-body {\n  background-color: rgba(15, 23, 42, 0.4);\n  border-color: #334155;\n}\n\n.dark .board-pricing-row {\n  color: #94a3b8;\n}\n\n.dark .board-pricing-total-row {\n  color: #f1f5f9;\n}\n\n.dark .board-pricing-divider {\n  border-top-color: #334155;\n}\n\n.dark .board-tiem-details-reprint-buttons {\n  background-color: #1e293b;\n  border-top: 1px solid #334155;\n}\n\n.dark .board-tiem-details-reprint-btn {\n  background-color: #1e293b;\n  border-color: #334155;\n  color: #e2e8f0;\n}\n\n.dark .board-tiem-details-reprint-btn:hover:not(:disabled) {\n  background-color: #334155;\n  border-color: #475569;\n  color: #f1f5f9;\n}\n\n.dark .board-details-slot {\n  background-color: #1e293b;\n  border-color: #334155;\n  color: #94a3b8;\n}\n\n.dark .board-item-details-right-box {\n  border-top-color: #334155;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
